import React from 'react';
import renderUtils from '../../../helpers/renderUtils';
import Price from '../../../components/lakeview/Price';
import SummaryRow from '../../../components/lakeview/SummaryRow';
import Percentage from '../../../components/lakeview/Percentage';
import Tooltip from '../../../components/tooltip/Tooltip';
import { FaInfoCircle } from 'react-icons/fa';

const ReservationSummary = ({ reservation, withoutTitle }) => {
  return (
    <>
      {!withoutTitle && <h3 className="mb-4">Szczegóły rezerwacji</h3>}

      <SummaryRow label="Numer rezerwacji" value={reservation.businessId} />
      <SummaryRow
        label="Data"
        value={renderUtils.formatDate(reservation.startDate, true)}
      />
      <SummaryRow
        label="Model płatności"
        value={renderUtils.renderPaymentModel(
          reservation.paymentSummary.paymentModel,
        )}
      />
      <SummaryRow
        label="Łączna kwota"
        value={<Price value={reservation.amount} />}
      />

      <SummaryRow
        label="Płatne przy rezerwacji %"
        value={
          <Percentage
            value={reservation.paymentSummary.paymentOnBookingPercentage}
          />
        }
        show={!!reservation.paymentSummary.paymentOnBookingPercentage}
      />

      <SummaryRow
        label="Płatne przy rezerwacji"
        value={<Price value={reservation.paymentSummary.paymentOnBooking} />}
        show={!!reservation.paymentSummary.paymentOnBooking}
      />
      <SummaryRow
        label="Termin płatności przy rezerwacji"
        value={renderUtils.formatDateWithTime(
          reservation.paymentDueOnBooking,
          true,
        )}
        show={!!reservation.paymentDueOnBooking}
      />
      <SummaryRow
        label="Rodzaj płatności przy rezerwacji"
        value={reservation.paymentTypeOnBooking?.name}
        show={!!reservation.paymentTypeOnBooking}
      />
      <SummaryRow
        label="Płatne przy zameldowaniu"
        value={<Price value={reservation.paymentSummary.paymentOnCheckin} />}
        show={!!reservation.paymentSummary.paymentOnCheckin}
      />
      <SummaryRow
        label="Termin płatności przy zameldowaniu"
        value={renderUtils.formatDateWithTime(
          reservation.paymentDueOnCheckin,
          true,
        )}
        show={!!reservation.paymentDueOnCheckin}
      />
      <SummaryRow
        label="Rodzaj płatności przy zameldowaniu"
        value={reservation.paymentTypeOnCheckin?.name}
        show={!!reservation.paymentTypeOnCheckin}
      />
      <SummaryRow
        label={
          <div className={'d-flex '}>
            Kaucja zwrotna
            {reservation.paymentSummary.securityDepositAmount > 0 ? (
              <Tooltip
                tooltip={'Płatna przy zameldowaniu'}
                divClassName={'ms-1'}
              >
                <FaInfoCircle />
              </Tooltip>
            ) : (
              ''
            )}
          </div>
        }
        value={
          <Price value={reservation.paymentSummary.securityDepositAmount} />
        }
        show={reservation.paymentSummary.securityDepositAmount > 0}
      />
      <SummaryRow
        label="Rodzaj płatności kaucji"
        value={reservation.paymentTypeDeposit?.name}
        show={!!reservation.paymentTypeDeposit}
      />
      <SummaryRow
        label="Faktura"
        value={reservation.needInvoice ? 'Tak' : 'Nie'}
        show={reservation.needInvoice !== undefined}
      />
      <SummaryRow
        label="Nazwa nabywcy do faktury"
        value={reservation.invoiceName}
        show={reservation.needInvoice === true}
      />
      <SummaryRow
        label="NIP"
        value={reservation.invoiceNip}
        show={reservation.needInvoice === true}
      />
      <SummaryRow
        label="Adres do faktury"
        value={reservation.invoiceAddress}
        show={reservation.needInvoice === true}
      />
      <SummaryRow
        label="Zameldowanie"
        value={reservation.checkinTime}
        show={!!reservation.checkinTime}
      />
      <SummaryRow
        label="Wymeldowanie"
        value={reservation.checkoutTime}
        show={!!reservation.checkoutTime}
      />
      <SummaryRow
        label="Komentarz klienta"
        value={reservation.customerReservationComment}
        show={!!reservation.customerReservationComment}
      />
      <SummaryRow
        label="Komentarz"
        value={reservation.reservationComment}
        show={!!reservation.reservationComment}
      />

      <SummaryRow
        label="Komentarz"
        value={reservation.reservationComment}
        show={!!reservation.reservationComment}
      />

      <SummaryRow
        label="Powód anulacji"
        value={reservation.cancelationDescription}
        show={!!reservation.cancelationDescription}
      />

      <SummaryRow
        label="Maksymalny % zwrotu od kwoty rezerwacji"
        value={<Percentage value={reservation.cancelationRefundPercentage} />}
        show={reservation.cancelationRefundPercentage != null}
      />

      <SummaryRow
        label="Kaucja do zwrotu"
        value={
          <Percentage value={reservation.securityDepositRefundPercentage} />
        }
        show={reservation.securityDepositRefundPercentage != null}
      />
      <SummaryRow
        label="Notatki wymeldowania"
        value={reservation.checkoutNotes}
        show={reservation.checkoutNotes != null}
      />
    </>
  );
};

export default ReservationSummary;
